module.exports = __webpack_public_path__ + "media/images/share-messanger-9d11df63fcdd9186eb661a1443392f13.svg";